import type { IconSvgObject } from './types';

const Remove02Icon: IconSvgObject = [
  ["path", { d: "M20 13.498L20.002 10.5H4V13.498H20.002", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default Remove02Icon;
